import { generateTradingTimesObject } from "../../utils/tradingTimesObject";
import * as types from "../actions/ActionTypes";

const Venue = (state = {}, action) => {
  switch (action.type) {
    case types.SetVenueInfo:
      console.log({ action });
      const venueData = action.data;
      const trading_times = generateTradingTimesObject(venueData.trading_times);
      state = {
        ...venueData,
        trading_times,
      };
      return state;

    default:
      return state;
  }
};
export default Venue;
